export const ApplicationReviewCommentFragment = gql`
  fragment ApplicationReviewCommentFragment on ApplicationReviewComment {
    id
    feedbackText
    excerpt
    status
    howResolved
    createdAt
    manuallyMarkedAsPendingAt
    isAttachedToLatestApplicationReviewRound
    sourceRecordTask {
      id
      ownerUser {
        ...UserDataFragment
      }
    }
    manuallyMarkedAsPendingByUser {
      ...UserDataFragment
    }
    attachedCurrentApplicationReviewRecordTask {
      id
      ownerUser {
        ...UserDataFragment
      }
    }
  }
`
